import React from 'react';

import { Navbar } from '../components/Navbar';
import { InGameButton } from '../components/InGameButton';
import '../styles/campaign.css';

export class Campaign extends React.Component {
  render() {
    return (
      <div className="campaign">
        <Navbar />
        <p>campaign page</p>
        <InGameButton />
      </div>
    )
  }
}